import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddSubCategory({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const [image, setImage] = useState<string>("");

    const [fileName, setFileName] = useState<string>("");
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Sub-Category</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                     
                        <div className="control_group">
                            <label htmlFor="reject-reason">Sub-Category Name</label>
                            <TextField
                                id="reject-reason"
                                placeholder="Enter Name"
                                fullWidth
                                hiddenLabel

                            />
                        </div>
                        <div className="control_group">
                            <label htmlFor="reject-reason">Price</label>
                            <TextField
                                id="reject-reason"
                                placeholder="Enter Price"
                                fullWidth
                                hiddenLabel

                            />
                        </div>

                        <div className="footer_btn_flex">

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
